import { render } from "./ManagerGroupView.vue?vue&type=template&id=b9338d72"
import script from "./ManagerGroupView.vue?vue&type=script&lang=js"
export * from "./ManagerGroupView.vue?vue&type=script&lang=js"

import "./ManagerGroupView.vue?vue&type=style&index=0&id=b9338d72&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__